import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 8L7 5L10 8"
      stroke="#05034D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IncrementIcon = (props) => <Icon component={svg} {...props} />;

export default IncrementIcon;
